import ApiService from "../ApiService";

const ForceShippingFeeService = {
  async forceShippingFeeAll() {
    return ApiService.get(
      'force-shipping-fee/all'
    )
  },
  support(id) {
    return ApiService.post(`orders/searchOrder_support?idorder=${id}`)
  },
 
  getsupport(page, rowsPerPage, search, date, date2, searchType) {
    return ApiService.post(
      `/orders/searchOrder_report_support?page=${page}&perPage=${rowsPerPage}&searchString=${search}&dateAfter=${date}&dateBefore=${date2}&searchType=${searchType}`
    );
  },
  gethistory(page, rowsPerPage, date) {
    return ApiService.post(
      `/orders/searchOrder_History_status?page=${page}&perPage=${rowsPerPage}&idOrder=${date}`
    );
  },
}

export default ForceShippingFeeService
